<template>
  <div :class="{ 'is-loading': loading }">
    <!-- Preloader sadece loading true ise gösterilecek -->
    <div v-if="loading" class="preloader-component">
      <div class="status">
        <div class="spinner-chase">
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
        </div>
      </div>
    </div>
    <!-- Slot ile içerik -->
    <slot />
  </div>
</template>

<script>
export default {
  name: "Loader",
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.is-loading {
  position: relative;
}

/* Tam ekran preloader */
.preloader-component {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  z-index: 999;
  width: 100%;
  height: 100%;
}

/* Spinner container */
.status {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -20px 0 0 -20px;
}

/* Basit chase spinner */
.spinner-chase {
  width: 100%;
  height: 100%;
  position: relative;
}

.chase-dot {
  width: 6px;
  height: 6px;
  background-color: #333;
  border-radius: 50%;
  position: absolute;
  animation: chase 2s infinite linear;
}

.chase-dot:nth-child(1) { animation-delay: 0s; }
.chase-dot:nth-child(2) { animation-delay: -0.333s; }
.chase-dot:nth-child(3) { animation-delay: -0.666s; }
.chase-dot:nth-child(4) { animation-delay: -1s; }
.chase-dot:nth-child(5) { animation-delay: -1.333s; }
.chase-dot:nth-child(6) { animation-delay: -1.666s; }

@keyframes chase {
  0% { transform: rotate(0deg) translateX(16px) rotate(0deg); }
  100% { transform: rotate(360deg) translateX(16px) rotate(-360deg); }
}
</style>
